import { Grid, Typography } from "@material-ui/core";
import { Card } from "@material-ui/core";
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton";
import { styled } from "@material-ui/core/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import useCustomState from "../../hooks/State";
import User from "./User";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useMountAPI } from "../../hooks/APICall";
import Call from "../../service/API";

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const ListBuyers = (props) => {
  const expanded = useCustomState(true);
  const handleExpandClick = () => {
    expanded.handleChange(!expanded.value);
  };

  const thisProjectUsers = useCustomState([]);

  useEffect(() => {
    if (!props.isLoading.value) {
      thisProjectUsers.handleChange(extractUsersInfo(props.counters));
    }
  }, [props.isLoading.value]);

  return (
    <Grid container style={{ paddingRight: "16px", paddingLeft: "16px" }}>
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Card style={{ width: "100%", marginTop: "16px" }}>
          <CardHeader
            style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
            title={"لیست خریداران"}
            action={
              <ExpandMoree
                expand={expanded.value}
                onClick={handleExpandClick}
                aria-expanded={expanded.value}
                aria-label="show more"
              >
                <ExpandMore />
              </ExpandMoree>
            }
          />
          <Collapse in={expanded.value} timeout="auto" unmountOnExit>
            <CardContent
              style={{
                padding: "16px",
              }}
            >
              <Grid container>
                {thisProjectUsers.value.map((user, idx) => {
                  return (
                    <User
                      data={user}
                      key={idx}
                      index={idx}
                      projectId={props.projectId}
                    />
                  );
                })}
              </Grid>
            </CardContent>
          </Collapse>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ListBuyers;

const extractUsersInfo = (counters) => {
  // console.log("counters: ", counters);
  const results = [];
  const tempData = {};
  let userInfo, data;
  counters.map((counter) => {
    userInfo = counter.water_meter_user_info;
    if (userInfo.user_id) {
      if (tempData[userInfo.user_id]) {
        tempData[userInfo.user_id] = tempData[userInfo.user_id] + 1;
      } else {
        tempData[userInfo.user_id] = 1;
        data = {
          id: userInfo.user_id,
          name: userInfo.user_name + " " + userInfo.user_lastname,
          phoneNumber: userInfo.user_phone,
          counters: 0,
        };
        results.push(data);
      }
    }
  });
  results.map((user, idx) => {
    user.counters = tempData[user.id];
    results[idx] = user;
  });
  return results;
};
